// opervex-frontend/src/Opervex/Unifique/index.js

import _Services from "./Services";

class System {
  #_api;

  constructor(api) {
    this.#_api = api;

    this.Services = new _Services(this.#_api);
  }
}

export default System;
